<template>
  <!-- 地址 -->
    <section class="address_box" :class="['address_box',come=='wx'?'wx':'']">
      <img class="address_box_left" :src="require(`../../../assets/images/themes/icon_location_${common.theme}.png`)">
      <section class="address_box_right">
        <h2>{{common.userTenantInfo.company}}</h2>
        <p class="user_add">{{common.userTenantInfo.defaultBuild}}{{common.userTenantInfo.defaultFloor}}</p>
        <p class="user_tel" v-if="come != 'wx'">{{common.userTenantInfo.userName}} {{common.userTenantInfo.phone}}</p>
      </section>
    </section>
</template>

<script>
export default {
    props:{
        common:{
            type:Object,
            default:()=>{return {}}
        },
        come:{
          type:String,
          default:''
        }
    }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/common.less";
// 地址
.address_box{
  background:#fff url('../../../assets/images/line.jpg') left bottom repeat-x;
  background-size:auto 8px;
  .flex();
  padding:28px;
  margin-bottom:14px;
  .address_box_left{
    display: block;
    width:36px;
    height:36px;
    margin-right:10px;
    margin-top:4px;
  }
  .address_box_right{
    flex:1;
    h2{
      font-size:32px;
      font-weight:bold;
      color:rgba(51,51,51,1);
      line-height:44px;
      margin-bottom: 20px;
    }
    .user_add{
      font-size:26px;
      color:rgba(102,102,102,1);
      line-height:36px;
      margin-bottom:10px;
    }
    .user_tel{
      font-size:26px;
      color:rgba(51,51,51,1);
      line-height:36px;
      margin-bottom:8px;
    }
  }
}
.wx{
  background:#fff;
}

</style>